const CircleCompletedSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={32} height={32} className="fill-stepper-completed" rx={16} />
    <path
      className="fill-stepper-check-icon"
      fillRule="evenodd"
      d="M22.9 11.183a.625.625 0 0 1 0 .884l-9.166 9.167a.625.625 0 0 1-.884 0l-4.167-4.167a.625.625 0 1 1 .884-.884l3.725 3.725 8.724-8.725a.625.625 0 0 1 .884 0Z"
      clipRule="evenodd"
    />
  </svg>
)

export { CircleCompletedSvg }
